import {trackMessage} from '@aboutyou/legacy-tracking-sdk';
import {useCallback} from 'react';
import {useTrackingPageContextCallback} from '../context/PageTrackingContext';
import {useTracking} from '../utils/utils';

type TrackMessageData = Omit<
  Parameters<typeof trackMessage>[0],
  'page_type' | 'page_type_id'
>;

export const useTrackMessage = () => {
  const {TrackingClient} = useTracking();
  const getContext = useTrackingPageContextCallback();

  return useCallback(
    (data: TrackMessageData) => {
      const context = getContext();
      TrackingClient.track(
        trackMessage({
          page_type: context.type,
          page_type_id: context.id,
          ...data,
        }),
      );
    },
    [TrackingClient, getContext],
  );
};
